import React, { useCallback, useEffect, useState } from 'react';
import { interval } from 'rxjs';

import styles from './CasinoMultiGameImage.scss';

export interface Props {
  multiGameList: string[];
  alt?: string;
}

const CasinoMultiGameImage: React.FC<Props> = ({ multiGameList, alt }) => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const nextSlide = useCallback(() => {
    setCurrentSlide((currentSlide + 1) % multiGameList.length);
  }, [currentSlide, multiGameList.length]);

  useEffect(() => {
    const subscription = interval(4000).subscribe((x) => nextSlide());
    return () => subscription.unsubscribe();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [nextSlide]);

  return (
    <div className={styles.container}>
      {multiGameList.map((image, index) => (
        <img
          alt={alt}
          key={index}
          src={image}
          className={index === currentSlide ? styles.slide && styles.active : styles.slide}
          // suppress hydration warning due to protocol mismatch (// on server vs https:// on client)
          suppressHydrationWarning
        />
      ))}
    </div>
  );
};

export default CasinoMultiGameImage;
